// extracted by mini-css-extract-plugin
export default {"btn":"closeChatButton_btn__mfcJQ"};